import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { useLocation } from "react-router-dom";
import { Container } from "@mui/system";
import CssBaseline from "@mui/material/CssBaseline";
import { WebContext } from "../contextProvider/webContextProvider";

const toolbarStyle = {
    minHeight: "0",
};

const NavBar = (props:any) => {
    const { webContent } = React.useContext(WebContext);
    const { window } = props;
    const location = useLocation()
    const currentLocation = location.pathname
    const [mobileOpen, setMobileOpen] = React.useState(false);


    return (
        <Box sx={{ display: "flex" }}>
            <CssBaseline />
            <AppBar position="static"
                component="nav"
                sx={{
                    backgroundColor: "#fff",
                    boxShadow: "none",
                    borderBottom: "1px solid #E2E2E2",
                }}
            >
                <Container maxWidth="lg">
                    <Toolbar className="p-0" style={toolbarStyle}>
                        <React.Fragment>
                            {currentLocation === '/get-information' ?
                                <Box sx={{ flexGrow: 1 }}>
                                    <Box className="lead-frm-logo" mt={1} mb={1}>
                                        <img src={webContent?.defaultData?.footerLogo} alt="header logo" />
                                    </Box>
                                </Box> :
                                <React.Fragment>
                                    <Box sx={{ flexGrow: 1 }}>
                                        <Box className="header-logo">
                                            <img src={webContent?.defaultData?.footerLogo} alt="header logo" />
                                        </Box>
                                    </Box>
                                </React.Fragment>
                            }
                        </React.Fragment>
                    </Toolbar>
                </Container>
            </AppBar >
        </Box >
    );
}

export default NavBar;
